import { isEmpty } from 'lodash';
import { match } from 'ts-pattern';
import { Creator } from '~/clientApi/creator.model';
import { IGInsights } from '~/hooks/api/insights/useGetIGInsights';
import { SnapchatInsights } from '~/hooks/api/insights/useGetSnapchatInsights';
import { TTInsights } from '~/hooks/api/insights/useGetTTInsights';
import { YTInsights } from '~/hooks/api/insights/useGetYTInsights';

import { Platform } from '../AddTalent/constants';

type CreatorAndPlatform = {
  creator?: Creator;
  platform: Platform;
};
export const getInsightId = ({ creator, platform }: CreatorAndPlatform) => {
  return match(platform)
    .with('instagram', () => creator?.insight?.id)
    .with('tiktok', () => creator?.tiktokInsight?.id)
    .with('youtube', () => creator?.ytChannels.at(0)?.id)
    .with('snapchat', () => creator?.snapchatInsight?.id)
    .otherwise(() => null);
};

export const getPlatformStatus = ({
  creator,
  platform,
}: CreatorAndPlatform) => {
  const status = match(platform)
    .with('instagram', () => creator?.platforms.instagram?.status)
    .with('tiktok', () => creator?.platforms.tiktok?.status)
    .with('youtube', () => creator?.platforms.youtube?.status)
    .with('snapchat', () => creator?.platforms.snapchat?.status)
    .otherwise(() => 'not-available');

  /**
   * Keeping this comment for reference such that both disconnected and connected
   * statuses should be considered as connected:
  
   * const isConnected = status === 'connected' || status === 'disconnected';
   */
  return status || 'not-available'; // Status should be not-available if it's undefined
};

export const getIsEmptyData = (
  insights?: IGInsights | TTInsights | YTInsights | SnapchatInsights,
) => {
  // if insights is undefined, return true (means that it's empty)
  if (!insights) return true;

  const genders = insights?.genders;
  const ages = insights?.ages;
  const countries = insights?.countries;

  const isValueEmpty = isEmpty(genders) || isEmpty(ages) || isEmpty(countries);

  return isValueEmpty;
};
